module.exports = new __parcel__URL__("brickwarriors.b43feab8.png").toString();